<template>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="visibleAdd"
      class="detail-info-dia"
      width="750px"
    >
        <div class="fo-item">
            <span class="label">标题：</span>
            <span class="text">{{dialogData.credentialsInfo.credential_title}}</span>
        </div>
        <div class="fo-item">
            <span class="label">备注：</span>
            <span class="text">{{dialogData.credentialsInfo.remark || '--'}}</span>
        </div>
        <div class="fo-item">
            <span class="label">附件：</span>
            <div >
                <span class="text fileList" v-for="(item, index ) in dialogData.fileList" :key="index"><a :href="item.file_address" target="_blank">{{index+1}}：{{item.file_title}}</a></span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "Seedetails",
        props: {
            dialogTitle: {
                type: String,
                default: '添加新文件'
            },
            dialogData: {
                type: Object,
            },
            isShowAddDialog: {
                type: Boolean,
                default: false
            },

        },
        computed: {
            visibleAdd: {
                get() {
                    return this.isShowAddDialog;
                },
                set(val) {
                    this.$emit('update:isShowAddDialog', val)
                }
            }
        },
        created() {

        },
        data() {
            return {

            }
        }
    }
</script>

<style lang="stylus" scoped>
    $margin = 5px
    .detail-info-dia{
        .fo-item{
            display:flex;
            padding-right:$margin;
            padding-left:$margin;
            margin-bottom:6px;
            font-size:16px;
            .label{
                width:80px;
                text-align:right;
            }
            .text{
                word-wrap:break-word;
                width: 600px;
            }
            .fileList{
                color:#4cd964
                display:block
            }
        }
    }
</style>
